// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"d0bac00e","118":"9ad23e26","217":"b810bca5"}[chunkId] + ".chunk.css";
};